var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8 0H24.178C24.4495 0.176234 25.0734 0.395734 25.3965 0.53321C28.7344 1.95335 32.2747 2.91559 35.8729 3.37691C37.233 3.61897 38.5964 3.66018 39.9711 3.73658C40.5637 3.7695 41.4432 3.69741 41.9857 3.86077C43.8791 4.43093 43.5122 6.64561 43.5113 8.15336L43.5116 12.3148L43.5125 19.5559C43.5128 21.6165 43.5783 23.7567 43.3326 25.7984C42.5603 32.2187 39.0117 38.16 33.7243 41.8812C32.8352 42.5066 31.9296 43.0674 31.016 43.6531L27.0608 46.1934L24.8483 47.605C24.6845 47.7103 24.2869 47.918 24.1745 48H23.8182L18.2733 44.4802C16.6023 43.425 14.7721 42.3316 13.2273 41.1067C8.52223 37.3757 5.39851 31.8015 4.67073 25.842C4.43133 23.8818 4.48499 21.878 4.48481 19.9136L4.4849 13.0424L4.48391 8.13379C4.48397 7.31476 4.44399 6.27702 4.54993 5.48927C4.66774 4.81149 5.24284 4.09392 5.90736 3.88695C6.53651 3.69103 7.35003 3.77937 8.0176 3.73511C8.85017 3.67993 9.69221 3.6533 10.5244 3.59012C11.0162 3.55281 11.5151 3.45783 12.0057 3.39319C15.6009 2.94102 19.1169 1.99675 22.455 0.586887C22.7781 0.446903 23.5438 0.182757 23.8 0ZM24.0974 46.2967L29.9192 42.5575C31.3949 41.6113 32.7613 40.791 34.125 39.6736C37.8919 36.5755 40.4945 32.2896 41.506 27.5182C41.7822 26.2458 41.9462 24.9517 41.9965 23.6506C42.0462 22.5877 42.0168 21.326 42.0171 20.2496L42.0165 14.3081L42.0177 8.92345C42.018 8.01393 42.0243 7.09365 42.0102 6.18443C42.0072 5.97809 41.9447 5.6248 41.8331 5.44818C41.4644 5.21171 39.7195 5.24385 39.1871 5.21521C34.7399 4.97593 30.3292 4.07087 26.1678 2.47549C25.7319 2.30839 24.2435 1.60966 23.8555 1.65363C22.7298 2.09064 21.7437 2.53951 20.5734 2.94612C17.3685 4.03772 14.0495 4.76035 10.6808 5.1C10.0515 5.16108 9.39041 5.141 8.75947 5.21767C7.95754 5.3151 7.04392 5.15156 6.27975 5.40102C6.05603 5.47403 5.98915 5.92525 5.98768 6.1332C5.98173 6.97365 5.98795 7.81502 5.98798 8.65595L5.98756 13.7545L5.98693 19.9693C5.98672 21.9004 5.92274 23.8743 6.17534 25.7907C6.94708 31.6453 10.1117 36.9926 14.8805 40.4774C15.4958 40.9272 16.1247 41.3126 16.7616 41.722L19.7864 43.6602L22.6712 45.5078C22.8868 45.6464 23.912 46.3867 24.0974 46.2967Z",
    fill: "url(#paint0_linear_6653_133505)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6848 5.75488C22.4229 5.75539 22.7806 6.43167 22.3015 6.96757C21.9836 7.3232 21.0663 7.49689 20.5856 7.64615C17.8261 8.52958 14.9851 9.13463 12.1051 9.45229C11.5986 9.50559 10.9702 9.59991 10.473 9.61436C10.5241 14.0862 10.4285 18.6013 10.4761 23.075C10.5335 27.7028 12.4313 32.1174 15.7502 35.343C16.2824 35.8538 16.9605 36.4057 17.5464 36.8495C17.9644 37.1661 18.2961 37.3097 18.6987 37.7035C18.8358 38.1871 18.813 38.3948 18.4445 38.747L18.093 38.8335C17.6914 38.8311 17.2176 38.4744 16.8958 38.2431C12.8552 35.3882 10.1176 31.0419 9.28794 26.1647C9.1631 25.4023 9.02044 24.3986 8.99617 23.6453C8.96293 22.6125 8.97867 21.5242 8.97861 20.4871L8.97924 14.9713L8.97735 11.0209C8.97669 10.5558 8.79095 8.39922 9.38272 8.23981C9.97473 8.08034 10.9843 8.04227 11.6366 7.9741C14.123 7.7142 16.5604 7.20844 18.9745 6.56256C19.8139 6.34187 20.8679 5.88407 21.6848 5.75488Z",
    fill: "url(#paint1_linear_6653_133505)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1828 5.75586C26.8288 5.78543 28.0589 6.30349 28.7449 6.48968C31.6592 7.28423 34.6853 7.88997 37.702 8.09391C38.9332 8.17714 39.063 8.42887 39.0256 9.6663C39.0166 9.96274 39.0217 10.3346 39.0214 10.6356L39.0217 13.8534L39.0229 20.0485C39.0232 21.7539 39.0903 23.4828 38.85 25.1719C38.7979 25.539 38.7518 25.9094 38.6908 26.2748C38.3637 28.1905 37.7269 30.0401 36.8052 31.7509C35.44 34.2338 33.7732 36.2257 31.5024 37.9371C31.0931 38.2456 30.5044 38.7035 30.0196 38.8441C29.88 38.8528 29.5685 38.7923 29.4785 38.7127C28.8462 38.1525 29.3885 37.4233 29.9918 37.1485C30.098 37.1004 30.3566 36.905 30.4413 36.8418C31.1125 36.3406 31.7523 35.798 32.3562 35.2172C35.3565 32.2588 37.1759 28.3081 37.4737 24.105C37.5336 23.3642 37.521 22.6044 37.521 21.8606V18.9777C37.521 15.8868 37.4815 12.7045 37.5225 9.6201C36.4865 9.50465 35.375 9.41215 34.3552 9.25687C32.3727 8.93876 30.4093 8.51191 28.4735 7.97822C28.14 7.88381 27.7859 7.76369 27.4527 7.65267C26.9757 7.49379 26.281 7.36931 25.8622 7.10611C25.2983 6.75174 25.4476 5.85988 26.1828 5.75586Z",
    fill: "url(#paint2_linear_6653_133505)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0778 18.0218L29.1101 18.0196C29.3672 18.0045 29.5929 18.0425 29.7879 18.2255C29.9246 18.355 30.0015 18.5353 30.0003 18.7236C30 19.1808 29.3789 19.7416 29.0687 20.0793C28.6512 20.5303 28.2389 20.986 27.8318 21.4464L25.4524 24.09C24.6979 24.9375 23.9336 25.7781 23.1743 26.6206C22.4984 27.3705 22.1203 26.9507 21.5587 26.3798C21.3969 26.2154 21.221 26.0402 21.0567 25.876L18.8935 23.7122C18.6343 23.4592 18.1565 23.054 18.0446 22.7189C17.8583 22.1609 18.2347 21.8562 18.7326 21.7236C19.3016 21.8524 20.006 22.6908 20.434 23.1179L22.4769 25.1649C22.9578 24.6464 23.4939 24.0057 23.978 23.4649L26.9788 20.1438L28.1176 18.8635C28.3816 18.5681 28.695 18.1266 29.0778 18.0218Z",
    fill: "url(#paint3_linear_6653_133505)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6653_133505",
    x1: 4.47656,
    y1: 24,
    x2: 43.5405,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#87959C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0769231,
    stopColor: "#89959C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.139423,
    stopColor: "#8B949B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211538,
    stopColor: "#B1B3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#C3C8CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389423,
    stopColor: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#D2DBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634615,
    stopColor: "#D2DBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817308,
    stopColor: "#9AB0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947115,
    stopColor: "#A5B7C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6653_133505",
    x1: 8.94922,
    y1: 22.2942,
    x2: 22.5194,
    y2: 22.2942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#87959C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0769231,
    stopColor: "#89959C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.139423,
    stopColor: "#8B949B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211538,
    stopColor: "#B1B3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#C3C8CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389423,
    stopColor: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#D2DBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634615,
    stopColor: "#D2DBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817308,
    stopColor: "#9AB0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947115,
    stopColor: "#A5B7C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6653_133505",
    x1: 25.5195,
    y1: 22.3004,
    x2: 39.0317,
    y2: 22.3004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#87959C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0769231,
    stopColor: "#89959C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.139423,
    stopColor: "#8B949B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211538,
    stopColor: "#B1B3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#C3C8CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389423,
    stopColor: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#D2DBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634615,
    stopColor: "#D2DBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817308,
    stopColor: "#9AB0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947115,
    stopColor: "#A5B7C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6653_133505",
    x1: 17.9961,
    y1: 22.5207,
    x2: 30.0003,
    y2: 22.5207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#87959C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0769231,
    stopColor: "#89959C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.139423,
    stopColor: "#8B949B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211538,
    stopColor: "#B1B3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#C3C8CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389423,
    stopColor: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#D2DBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634615,
    stopColor: "#D2DBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817308,
    stopColor: "#9AB0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947115,
    stopColor: "#A5B7C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature_2.61f190b36a34abbd9e5cc43411500f93.svg";
export { ForwardRef as ReactComponent };